export const projectStatusOptions = [
    "New Project",
    "Screening",
    "Presentation Round",
    "Rehearsals",
    "Mentor Round 1",
    "Budget Round",
    "Mentor Round 2",
    "Tech Rehearsals",
    "Showcase",
    "Not Accepted",
];